import { useNavigate } from 'react-router-dom'

import heroGraphic from '../../assets/img-hero2x.png'
import { ReactComponent as CtaArrowIcon } from '../../assets/cta-arrow.svg'

const Hero = () => {
    const navigate = useNavigate()

  return (
    <section className="relative overflow-hidden bg-brand-pageFill">
      {/* M1.2.1: the 32px gap to the Workflow section is owned by that section's top
          padding, so the hero adds nothing below it on mobile. */}
      {/* D1.2.1: 80px from the banner, not 120. Measured in the section export — the banner
          ends at y936 and the hero content starts at y1016. Mobile pt is untouched; his item
          is under Desktop. */}
      {/* `md:items-start` is what actually delivers the 80px: with `items-center` the text
          column was centred against the taller image, so it sat 66px below the padding and no
          amount of `pt` would fix it. The file top-aligns them — hero-txt y1013, image y1015. */}
      {/* 13.08 set #4 D1.1: 72px from the banner (was 80). Dropped the fixed min-height that
          used to sit here — nothing in this section is absolutely positioned against it, unlike
          Tools/CallToAction's radial blobs.
          14.08 followup: this section's own bottom edge is the dark/light boundary, so it's the
          only place that can add light-background space before it — Tools.jsx's padding sits
          after the boundary and can't (see Tools.jsx). pb below is that space. */}
      <div className="max-w-canvas mx-auto px-6 md:px-0 pt-[60px] md:pt-[72px] pb-0 md:pb-[32px] flex flex-col md:flex-row items-center md:items-start justify-between gap-6 md:gap-12 relative z-10">
        <div className="w-full md:w-[620px] md:shrink-0">
          {/* Desktop type scale pinned to the Figma `homepage` frame: H1 52/72 (increased line-height per Микола's review). */}
          <h1 className="text-[32px] md:text-[52px] leading-[1.3] md:leading-[72px] font-extrabold tracking-[-1px] md:tracking-[-2px]">
            <span className="text-brand-dark">Smarter Deal Analysis</span>
            <br />
            <span className="text-brand-primary">Invest With Confidence</span>
          </h1>

          <p className="mt-4 md:mt-6 text-[16px] md:text-[20px] leading-[1.6] md:leading-[36px] text-brand-dark max-w-[588px]">
            Analyze deals faster with data you can trust.
          </p>

          {/* D1.2.2: 6px between the rows on desktop, not 12. The rows are 36px tall and the
              export has them at y1264 / 1306 / 1348 — a 42px step. Mobile keeps 12. */}
          <ul className="mt-4 flex flex-col gap-3 md:gap-[6px]">
            {[
              'Find profitable deals',
              'Instant ARV, comps & rents',
              'Track deals to closing',
            ].map((item) => (
              <li key={item} className="flex items-center gap-2">
                <span className="w-[20px] h-[20px] rounded-full bg-brand-primary flex items-center justify-center shrink-0">
                  <svg width="10" height="8" viewBox="0 0 12 9" fill="none">
                    <path d="M1 4.5L4.5 8L11 1" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <span className="text-[15px] md:text-[20px] md:leading-[36px] text-brand-dark">{item}</span>
              </li>
            ))}
          </ul>

          <button
            onClick={() => navigate('/signup')}
            className="flex items-center gap-2 mt-6 md:mt-8 h-[56px] px-10 rounded-full bg-brand-primary hover:bg-brand-hover text-white text-[16px] font-semibold shadow-soft transition-colors"
          >
            Analyze Deals Free
            <CtaArrowIcon/>
          </button>
        </div>

        {/* D1.2.3: the image was a fixed 650px next to a fixed 620px column, which is
            wider than the 1200px canvas — so it ran past the right edge and the section's
            overflow-hidden cropped it. `min-w-0` lets the column give way, and the image
            now ends exactly where the Logout / CTA button does. */}
        <div className="flex-1 min-w-0 flex justify-center md:justify-end w-full">
          <img
            src={heroGraphic}
            alt="hero"
            className="w-full max-w-[500px] md:max-w-[650px]"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero